import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'app-badge',
    templateUrl: './badge.component.html',
    styleUrls: ['./badge.component.scss'],
    standalone: false
})
export class BadgeComponent
  implements OnInit, ICellRendererAngularComp, OnChanges
{
  @Input('message') message: string;
  @Input('color') color: string;
  @Input('needTranslation') needTranslation: boolean = true;
  badgeColor: string = 'primary';

  message$: BehaviorSubject<string> = new BehaviorSubject<string>('');

  ngOnInit() {
    if (this.color) this.badgeColor = this.color;
    this.message$.next(this.message);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.color) this.badgeColor = this.color;
    if (changes['message']) {
      this.message$.next(changes['message'].currentValue);
    }
  }

  agInit(params: any): void {
    if (params) {
      this.message = params.value;
      this.badgeColor = params.data[params.color] ?? 'primary';
    }
  }
  refresh(params: ICellRendererParams): boolean {
    return false;
  }
}
